import Util from './../../../libs/util'
const { ajax, globalModalContain } = Util
function http({ url, type, params, fail, final }) {
    return new Promise((resolve, reject) => {
        ajax[type](url, params).then(
            res => {
                const { code, data, msg = '' } = res.data || {}
                if (code === 1) {
                    resolve(data)
                } else {
                    globalModalContain.$Modal.error({
                        title:'错误',
                        content: msg
                    })
                    reject(new Error(''))
                }
            }
        ).catch(() => {
            globalModalContain.$Modal.error({
                title:'错误',
                content: '网络错误'
            })
            if (fail) {
                fail()
            }
            reject(new Error('网络错误'))
        }).finally(() => {
            if (final) {
                final()
            }
        })
    })
}

// 获取Overview数据
export function getOverviewDataApi(params, callBack) {
    return http({
        url: '/cash_income/overview',
        type:'get',
        final: callBack,
        params
  })
}

// 获取历史趋势数据

export function getHistoryDataApi(params, callBack) {
    return http({
        url: '/cash_income/historical_trend',
        type:'get',
        final: callBack,
        params
  })
}

// 获取历史分解数据

export function getHistoryDataDecomposeApi(params, callBack) {
    return http({
        url: '/cash_income/indicators',
        type:'get',
        final: callBack,
        params
  })
}

// 获取数据导出数据

export function getDataExportApi(params, callBack) {
    return http({
        url: '/cash_income/export_list',
        type:'get',
        final: callBack,
        params
  })
}

// 获取可以选择的组
export function getCanSelectApi(params, callBack) {
    return http({
        url: '/cash_income/teams',
        type:'get',
        final: callBack,
        params
  })
}

// 
export function getTendencyApi(params, callBack) {
    return http({
        url: '/cash_income/user_distribution_trend',
        type:'get',
        final: callBack,
        params
  })
}